import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { axiosProperty, throwResponse } from "config/axios";
import { IDashboardParams } from "../../interface";
import { IVehicle, IVehicleBrand } from "./interface";

export const useGetPropertyDashboardVehicle = (
  params?: IDashboardParams
): UseQueryResult<IVehicle[], Error> => {
  return useQuery(
    ["dashboard-property-vehicle", "most-used-vehicle-types", params],
    async () => {
      const res = await axiosProperty.get(
        "dashboard/vehicle/most-used-vehicle-types",
        { params }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    { enabled: params?.enabled }
  );
};

export const useGetPropertyDashboardMostVehicle = (
  params?: IDashboardParams
): UseQueryResult<IVehicleBrand[], Error> => {
  return useQuery(
    ["dashboard-property-vehicle", "graph-of-sticker", params],
    async () => {
      const res = await axiosProperty.get(
        "dashboard/vehicle/graph-of-sticker",
        { params }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    { enabled: params?.enabled }
  );
};
